import posthog from 'posthog-js';

export const initPostHog = () => {
	console.log('initializing posthog');
	if (import.meta.env.VITE_POSTHOG_KEY) {
		posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
			api_host: import.meta.env.VITE_POSTHOG_HOST,
			session_recording: {
				maskAllInputs: false,
			},
			loaded: (posthog) => {
				if (import.meta.env.DEV) posthog.debug();
			},
		});
	}
};

export const identifyUser = (user) => {
	if (import.meta.env.VITE_POSTHOG_KEY && user) {
		posthog.identify(user.id, {
			email: user.email,
			name: `${user.firstName} ${user.lastName}`,
			role: user.role,
		});
	}
};
